module.exports = __webpack_public_path__ + "27b25c79a94e08f0f340741b2ef46ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tipbear.png
// module id = 457
// module chunks = 0